









































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import { Route } from "vue-router";
import anime from "animejs";
import ContentContainer from "../components/ContentContainer.vue";

@Component({
  components: {
    ContentContainer
  }
})
export default class ObjectPage extends Vue {
  @State(state => state.app.scrollingByScreens) scrollingByScreens!: boolean;

  get screenHeight() {
    return (this.$browser.height < 350) ? 350 : this.$browser.height;
  }

  get containerHeight() {
    let height = (this.scrollingByScreens) ? this.screenHeight - 130 : this.screenHeight - 30
    return height;
  }

  toHome() {
    this.$router.push("/");
  }
}
